import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [wishlist, setWishlist] = useState([]);

    useEffect(() => {
        const savedCart = JSON.parse(localStorage.getItem('cart')) || [];
        const savedWishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        setCart(savedCart);
        setWishlist(savedWishlist);
    }, []);

    const updateLocalStorage = (key, data) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const updateCart = (updatedCart) => {
        setCart(updatedCart);
        // Check if the user is logged in, if not, store cart data in localStorage
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (!userInfo || !userInfo.buyer_id) {
            // If user is not logged in, store the cart in localStorage
            updateLocalStorage('cart', updatedCart);
        }
    };

    const updateWishlist = (updatedWishlist) => {
        setWishlist(updatedWishlist);
        // Check if the user is logged in, if not, store wishlist data in localStorage
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (!userInfo || !userInfo.buyer_id) {
            // If user is not logged in, store the wishlist in localStorage
            updateLocalStorage('wishlist', updatedWishlist);
        }
    };

    const addToCart = (item) => {
        const isInCart = cart.some(cartItem => cartItem.product_id === item.product_id);
        const updatedCart = isInCart 
            ? cart.filter(cartItem => cartItem.product_id !== item.product_id)
            : [...cart, item];
        updateCart(updatedCart);
    };

    const addToWishlist = (item) => {
        const isInWishlist = wishlist.some(wishlistItem => wishlistItem.product_id === item.product_id);
        const updatedWishlist = isInWishlist
            ? wishlist.filter(wishlistItem => wishlistItem.product_id !== item.product_id)
            : [...wishlist, item];
        updateWishlist(updatedWishlist);
    };

    // Clear cart function
    const clearCart = () => {
        setCart([]);
        localStorage.removeItem('cart'); // Remove cart from localStorage
    };

    // Clear wishlist function
    const clearWishlist = () => {
        setWishlist([]);
        localStorage.removeItem('wishlist'); // Remove wishlist from localStorage
    };

    return (
        <CartContext.Provider value={{ 
                cart, 
                wishlist, 
                addToCart, 
                addToWishlist, 
                updateCart, 
                updateWishlist,
                clearCart, 
                clearWishlist // Include clearCart and clearWishlist here
                }}>
            {children}
        </CartContext.Provider>
    );
};
